export const FIELD_UM_ID = 'umId';
export const FIELD_APPLICATION_ID = 'applicationId';

export const LAST_ACTIVITY = 'lastActivityDate';
export const PREVIOUS_ACTIVITY = 'previousActivityDate';
